// extracted by mini-css-extract-plugin
export default {"input":"PaymentsOS_input__jxGGE","button":"PaymentsOS_button__5qhn9"};